import { render, staticRenderFns } from "./VolunteerStandardMatchCustomer.vue?vue&type=template&id=0d4a38bb"
import script from "./VolunteerStandardMatchCustomer.vue?vue&type=script&lang=ts"
export * from "./VolunteerStandardMatchCustomer.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerStandardMatchCustomer.vue?vue&type=style&index=0&id=0d4a38bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports